import {
    Directive, OnInit, inject
} from "@angular/core";
import { MatDateRangePicker } from "@angular/material/datepicker";
import { PanelTriggerHostDirective } from "../../../directives/panel-trigger/panel-trigger-host.directive";

/**
 * Attribute directive that wires a `<mat-date-range-picker>` element into the
 * application's close-all-panels signal via `PanelTriggerHostDirective`.
 *
 * When a hotkey fires, `AppService.closeAllPanels()` is invoked, which causes
 * every subscribed `PanelTriggerHostDirective` to synchronously close its panel —
 * including this one.
 *
 * Must be placed on the `<mat-date-range-picker>` element, not on the associated input.
 *
 * @example
 * ```html
 * <mat-date-range-picker mgdDateRangePickerTrigger #picker></mat-date-range-picker>
 * <mat-date-range-input [rangePicker]="picker">...</mat-date-range-input>
 * ```
 *
 * @selector mat-date-range-picker[mgdDateRangePickerTrigger]
 */
@Directive({
    selector: "mat-date-range-picker[mgdDateRangePickerTrigger]",
    hostDirectives: [PanelTriggerHostDirective]
})
export class DateRangePickerTriggerDirective implements OnInit {
    private readonly _picker = inject(MatDateRangePicker<unknown>, { self: true });
    private readonly _panelTrigger = inject(PanelTriggerHostDirective, { self: true });

    ngOnInit(): void {
        this._panelTrigger.setTrigger(this._picker);
    }
}
